module.exports = __webpack_public_path__ + "static/media/bookmark-filled-icon.6e41f846.svg";